import type { IPublicClientApplication } from '@azure/msal-browser';

import { CONFIG } from 'src/global-config';

const apiScopes: string[] = CONFIG.msal.scopes;

/** **************************************
 * Sign in
 *************************************** */
// Never returns
export const signInWithMsal = (
  msalClient: IPublicClientApplication,
  scopes?: string[]
): Promise<void> =>
  msalClient.loginRedirect({
    scopes: scopes ?? apiScopes,
  });

/** **************************************
 * Sign out
 *************************************** */
// Never returns
export const signOutWithMsal = (msalInstance: IPublicClientApplication): Promise<void> =>
  msalInstance.logoutRedirect();

/** **************************************
 * Sign up
 *************************************** */
// Never returns
export const signUpWithMsal = (msalClient: IPublicClientApplication): Promise<void> =>
  msalClient.loginRedirect({
    scopes: apiScopes,
    prompt: 'create',
  });
